module.exports = __webpack_public_path__ + "media/47.8fd630b7.mp3";